import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@client/components/ui/dialog';
import { SeatInvitationConsentDialog } from './SeatInvitationConsentDialog';

interface ConsentData {
  hasConsented: boolean;
  ipAddress: string | null;
  userAgent: string;
}

interface AcceptSeatInvitationDialogProps {
  open: boolean;
  invitation: PendingSeatInvitation | null;
  onAccept: (consentData: ConsentData) => void;
  onDecline: () => void;
  isSubmitting?: boolean;
}

export function AcceptSeatInvitationDialog({
  open,
  invitation,
  onAccept,
  onDecline,
  isSubmitting = false,
}: AcceptSeatInvitationDialogProps) {
  if (!invitation) {
    return null;
  }

  const ownerName =
    invitation.ownerFirstName && invitation.ownerLastName
      ? `${invitation.ownerFirstName} ${invitation.ownerLastName}`
      : invitation.ownerEmail;

  const ownerOrgName = invitation.ownerOrganizationDisplayName || invitation.ownerOrganizationName;

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen && !isSubmitting) {
          onDecline();
        }
      }}
    >
      <DialogContent className="max-h-[90vh] max-w-lg overflow-y-auto">
        <DialogHeader className="sr-only">
          <DialogTitle>
            {invitation.isTeamInvitation
              ? 'Accept Team Invitation'
              : 'Accept Subscription Invitation'}
          </DialogTitle>
          <DialogDescription>
            {invitation.isTeamInvitation
              ? 'Review and accept the invitation to join this team'
              : 'Review and accept the invitation to join this subscription'}
          </DialogDescription>
        </DialogHeader>
        <SeatInvitationConsentDialog
          ownerName={ownerName}
          ownerOrgName={ownerOrgName}
          expiresDateTime={invitation.expiresDateTime}
          onAccept={onAccept}
          isSubmitting={isSubmitting}
          isTeamInvitation={invitation.isTeamInvitation}
        />
      </DialogContent>
    </Dialog>
  );
}
